import React from 'react'
import { Route, Routes } from 'react-router-dom'
import TodaySales from '../pages/POS/TodaySales'
import TodaySalesDetails from '../pages/POS/TodaySalesDetails'
import CashierSales from '../pages/Transactions/CashierSales'
import PrintCashierSales from '../pages/Transactions/PrintCashierSales'
import CashierSaleItems from '../pages/Transactions/CashierSaleItems'
import CreditSalesRepaymentToday from '../pages/POS/CreditSalesRepaymentToday'
import SalesList from '../pages/Inventory/sale/SalesList'
import SaleDetail from '../pages/Inventory/sale/SaleDetail'
import ItemReturnList from '../pages/Inventory/sale/ItemReturnList'
import WitnessReturnVerification from '../pages/Inventory/sale/WitnessReturnVerification'

const SalesRoutes = () => {
  return (
    <Routes>
        <Route path="/list" element={<SalesList />} />
        <Route path="/branch/:branch_id/details/:sale_id" element={<SaleDetail />} />
        <Route path="/item-return" element={<ItemReturnList />} />
        <Route path="/witness-verification" element={<WitnessReturnVerification />} />
        <Route path="/today" element={<TodaySales />} />
        <Route path="/today/:branch_id" element={<TodaySalesDetails />} />
        <Route path="/cashier/" element={<PrintCashierSales />} />
        <Route path="/cashier/print" element={<CashierSales />} />
        <Route path='/cashier/:sale_id/details' element={<CashierSaleItems />} />
        <Route path="/credit/today" element={<CreditSalesRepaymentToday />} />
    </Routes>
  )
}

export default SalesRoutes